//  Copyright (c) 2020 Comsearch, Inc., All rights reserved

//  Copyright (c) 2020 Comsearch, Inc., All rights reserved

import { loadingToggler } from 'redux/modules/loading'
import { documentGenerationNotification } from 'components/Notifications'
import { throwSubmissionError } from 'helpers/reduxFormFunctions'

import {
  AFS_GRID_FILTER,
  EARTH_STATION_RESULTS_FORM,
} from 'redux/modules/interferenceAnalysis/constants'

import {
  assembleQuery,
  postEarthStationInterferenceCaseReport,
} from 'helpers/api'

const handleDownloadEarthStationCaseReports = (formValues, closeContextModal) => (dispatch, getState) => (
  dispatch(loadingToggler(
    async () => {
      const {
        form,
        projectSummary,
      } = getState()

      const projectId = projectSummary.get('projectId')

      const { bandId } = form[AFS_GRID_FILTER].values
      const { caseNumbers } = form[EARTH_STATION_RESULTS_FORM].values

      const {
        exportTypes,
        fileName,
      } = formValues

      const queryParams = [{
        field: 'bandId',
        value: bandId,
      }, {
        field: 'caseNumbers',
        value: caseNumbers,
      }, {
        field: 'exportTypes',
        value: exportTypes.join(','),
      }]

      if (fileName.length) {
        queryParams.push({
          field: 'fileName',
          value: fileName,
        })
      }

      const query = assembleQuery(queryParams)

      try {
        // gotta select a format for the report to go on.
        if (exportTypes.length === 0) {
          throw new Error('Must export at least one format.')
        }

        const { entity } = await postEarthStationInterferenceCaseReport(projectId, query)
        await dispatch(documentGenerationNotification(entity))
        closeContextModal()
      } catch (err) {
        console.warn(err)
        throwSubmissionError(err)
      }
    }
  ))
)
export default handleDownloadEarthStationCaseReports
